(function (angular) {
    'use strict';

    angular
        .module('Toyota.Directives')
        .directive('tyProvideFormFieldAnalytics', function () {

            function controller() {
                var tyProvideFormFieldAnalytics = this;

                tyProvideFormFieldAnalytics.$onInit = function () {
                    tyProvideFormFieldAnalytics.properties = {};
                };

                tyProvideFormFieldAnalytics.getFormDetails = function () {
                    return tyProvideFormFieldAnalytics.properties;
                };

                tyProvideFormFieldAnalytics.setFormDetails = function (data) {
                    tyProvideFormFieldAnalytics.properties = data;
                };
            }

            return {
                restrict: 'A',
                controller: controller,
                controllerAs: 'tyProvideFormFieldAnalytics'
            };
        });
})(window.angular);